import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const prefix = AuthLevel.AUTH

export const paths = {
  notification: generateApiPath({ prefix, name: 'notification' }),
}
